import type { TabName } from "./types";

export const TERMS_VERSION = "2026-10-24";
export const PRIVACY_VERSION = "2026-10-24";
export const APP_STORE_ID = "6757688273";
export const APP_STORE_URL = "https://apps.apple.com/us/app/lot-language-of-thoughts/id6757688273?itscg=30200&itsct=apps_box_artwork&mttnsubad=6757688273";
export const PUBLIC_SITE_URL = "https://lotapp.ai";

// Self-inquiry only — prompts point inward at the writer's own mind, never
// outward at opinions or takes.
export const DAILY_PROMPT_FALLBACK: string[] = [
  "What keeps returning for you lately?",
  "What are you carrying that you haven't said out loud?",
  "What do you understand logically but can't settle emotionally?",
  "When did you last feel most like yourself?",
  "What are you avoiding thinking about?",
  "What would you say if nobody could judge it?",
  "What has quietly changed in you this year?",
  "What do you keep circling without landing?",
];

// Order mirrors the iOS tab bar (Thoughts · Companion · Discovery · You) and
// drives the directional tab-switch animation. Secondary destinations
// (write/matches/friends/activity/settings) keep working as deep-linked routes
// reached from You, so they stay in the routing order after the primary four.
export const TAB_ORDER: TabName[] = [
  "notes",
  "companion",
  "feed",
  "you",
  "saved",
  "portrait",
  "write",
  "matches",
  "friends",
  "activity",
  "settings",
];

// Exactly the 4 primary tabs shipped on iOS.
export const PRIMARY_NAV_TABS: TabName[] = [
  "notes",
  "companion",
  "feed",
  "you",
];

export const TAB_LABELS: Record<TabName, string> = {
  feed: "Discovery",
  write: "Write",
  matches: "Matches",
  companion: "Companion",
  friends: "Friends",
  communities: "Communities",
  notes: "Thoughts",
  activity: "Activity",
  settings: "Settings",
  you: "You",
  saved: "Saved Thoughts",
  portrait: "Your portrait",
};

// Secondary tabs live inside the You hub (or Write inside Thoughts): when one
// of them is active, highlight its primary parent in the 4-tab nav so the
// selection never disappears.
export const PRIMARY_TAB_FOR: Partial<Record<TabName, TabName>> = {
  friends: "you",
  matches: "you",
  activity: "you",
  settings: "you",
  saved: "you",
  portrait: "you",
  write: "notes",
  communities: "feed",
};
